import React, { useState, useEffect } from "react";

// Components
import Sidebar from "../../components/Sidebar";
import Main from "./TbSetItmType/Main";
import Form from "./TbSetItmType/Form";

// Utils
import { getDataWithJoin, getAlert } from "../../../utils/SamuiUtils";

const TbSetItmType = () => {
    const [mode, setMode] = useState("");
    const [dataMasterList, setDataMasterList] = useState([]);
    const [selectedData, setSelectedData] = useState(null);
    const [formData, setFormData] = useState({ ItmType_Id: 0, ItmType_Name: "", ItmType_Status: "Y", ProdCat_Id: 0, comp_id: null });

    useEffect(() => {
        initialize();
    }, []);

    const initialize = async () => {
        try {
            setMode("S");
            fetchRealtime();
        } catch (error) {
            getAlert("FAILED", error.message);
        }
    };

  const fetchRealtime = async () => {
    try {
        const compId = localStorage.getItem("company");
        const masterList = await getDataWithJoin(
            "ItmType.*, PC.ProdCat_Name",
            "Tb_Set_ItmType ItmType",
            "LEFT JOIN Tb_Set_ProdCategory PC ON ItmType.ProdCat_Id = PC.ProdCat_Id",
            `WHERE ItmType.Comp_Id = ${compId} Order By ItmType_Id`
        );
        if (masterList && masterList.length > 0) {
            setDataMasterList(masterList);
        } else {
            setDataMasterList([]);
        }
    } catch (error) {
        getAlert("FAILED", error.message);
    }
};

    const onPageInsert = () => {
        setMode("I");
    };

    const onRowSelected = (item) => {
        setMode("U");
        setFormData({
            comp_id: item.Comp_Id,
            ItmType_Id: item.ItmType_Id,
            ItmType_Name: item.ItmType_Name,
            ItmType_Status: item.ItmType_Status,
            ProdCat_Id: item.ProdCat_Id || 0,
        });
        setSelectedData(item);
    };

    return (
        <div className="TbSetItmType">
            <div className="wrapper">
                <Sidebar />
                <div className="main-panel">
                    <div className="container">
                        <div className="page-inner">
                            <div style={{ display: mode === "S" ? "block" : "none" }}>
                                <Main
                                    masterList={dataMasterList}
                                    name={"ข้อมูลประเภทค่าใช้จ่าย"}
                                    onPageInsert={() => onPageInsert()}
                                    onRowSelected={(item) => onRowSelected(item)}
                                />
                            </div>
                            <div style={{ display: mode !== "S" ? "block" : "none" }}>
                                <Form
                                    callInitialize={initialize}
                                    mode={mode}
                                    name={"ข้อมูลประเภทค่าใช้จ่าย"}
                                    formData={formData}
                                    setFormData={setFormData}
                                    selectedData={selectedData}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TbSetItmType;
